<template>
  <div class="row">
    <div class="col-12">
      <h5 class="mb-3">Contactpersoon</h5>
    </div>
    <div class="form-group col-xl-4">
      <label for="vacancy-responsibleUser">Verantwoordelijke gebruiker</label>
      <v-select
          :options="options"
          :selectOnTab="true"
          id="vacancy-responsibleUser"
          :get-option-label="contactPersonName"
          :value="value"
          @input="$emit('input', $event)"
      >
        <div slot="no-options">Geen gebruikers gevonden</div>
      </v-select>
    </div>
    <div class="form-group col-xl-4">
      <label>Telefoonnummer</label>
      <p class="form-control-plaintext vacancy-contact-mobile" v-if="value && value.mobile">{{ value.mobile }}</p>
      <p class="form-control-plaintext vacancy-contact-mobile text-muted" v-else-if="value">Geen telefoonnummer bekend bij deze gebruiker</p>
      <p class="form-control-plaintext vacancy-contact-mobile text-muted" v-else>-</p>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';
import {contactPersonName, contactPersonOptions, workfixEmployeesOf} from '@/utils/vacancyContact';

export default {
  name: 'vacancyContactPerson',
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapGetters(['getUserData']),
    ...mapGetters('users', ['getUsers']),
    ...mapGetters('roles', ['getRoles']),
    options() {
      return contactPersonOptions(workfixEmployeesOf(this.getUsers, this.getRoles, this.getUserData.selectedDepartment));
    }
  },
  methods: {
    contactPersonName
  }
};
</script>
